module.exports = __webpack_public_path__ + "static/desktop-centrifugal-pump-c0922500b277d1194b3690bbdcfd7a2f.jpg";